import { EventHandlerConfig } from "@/widgetLibrary/interface"

export const STEPS_EVENT_HANDLER_CONFIG: EventHandlerConfig = {
  events: [],
  methods: ["setValue", "resetValue"],
}
